import lang from '../../../lang'

import { StringSchema } from '../..'

export default function base64Image(this: StringSchema) {
  return this
    .matches(/^data:image\/\w+;base64,/, lang().validation.base64ImageInvalid())
}
